export default {
  init() {

  },
  finalize() {
    const $navigation = $('.navigation-mobile');

    // Open/Close mobile menu
    $navigation.find('.nav-burger-button').on('click', function() {
      $navigation.toggleClass('open');
      $navigation.removeClass('second-level');
    });

    // Go to second level
    $navigation.find('.nav-link.nav-link-has-children').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const index = $(this).data('index');
      $navigation.find('.nav-main-second-level .nav-sub').hide();
      $navigation.find(`.nav-main-second-level .nav-sub[data-index="${index}"]`).show();

      $navigation.addClass('second-level');
    });

    // Return to first level
    $navigation.find('.nav-main-second-return').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      $navigation.removeClass('second-level');
    });
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/other/navigationMobile.js